import React, { useContext } from "react";

import BusinessView from "../components/BusinessView";
import { ConfigContext } from "../context/GlobalContext";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CustomerView from "../components/CustomerView";
import ExpensView from "../components/ExpensView";

const ExpenseViewPage = ({ }) => {
  const { state } = useContext(ConfigContext);


  return (
    <>
      <MasterLayout>
        <ExpensView state={state} />
      </MasterLayout></>

  );
};

export default ExpenseViewPage;
